<template>
  <v-menu
    v-model="isShowingMenu"
    :close-on-content-click=false
    v-bind:target="[positionX, positionY]"
    :persistent="false"
    location="bottom"
    absolute
  >
    <v-list width="260px">
      <!-- Restore selected -->
      <v-list-item v-if="!isArchived && $canControlNodeAndPod()" @click="onClickRestoreItem">

          <v-list-item-title>
            <v-icon>mdi-file-restore-outline</v-icon>
            {{
              itemType === 'pod'
                ? $t('routes.recycleBin.restoreFile')
                : $t('routes.recycleBin.restoreFolder')
            }}
          </v-list-item-title>

      </v-list-item>

      <v-divider v-if="!isArchived && $canControlNodeAndPod()" />

      <!-- Permanently delete selected -->
      <v-list-item v-if="$canDeleteNodeAndPod()" @click="onClickPermanentlyDeleteItem" >
      <!-- <v-list-item @click="showingDeleteConfirmDialog = true"> -->
          <v-list-item-title>
            <v-icon>mdi-delete-forever-outline</v-icon>
            <span class="text-error">
            {{
                itemType === 'pod'
                  ? $t('routes.recycleBin.permanentlyDeleteFile')
                  : $t('routes.recycleBin.permanentlyDeleteFolder')
              }}
          </span>
          </v-list-item-title>
        </v-list-item>
    </v-list>
  </v-menu>

  <RecycleBinConfirmationDialog
    v-model="showingDeleteConfirmDialog"
    type="delete-selected"
    :in-progress="deletionInProgress"
    :error-message="confirmationDialogErrorMessage"
    :is-showing-dialog="isShowingConfirmationDialog"
    @confirm="$emit('permanentlyDeleteItem')"
  />
</template>

<script>
import RecycleBinConfirmationDialog from '@/routes/recycle-bin/components/RecycleBinConfirmationDialog.vue';

export default {
  name: "RecycleBinContextMenu",
  components: { RecycleBinConfirmationDialog },
  props: {
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
    },
    isShowingConfirmationDialog: {
      type: Boolean,
      default: false,
    },
    confirmationDialogErrorMessage: {
      type: String,
      default: '',
    },
    deletionInProgress: {
      type: Boolean,
      default: false,
    },
    isArchived: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['restoreItem', 'permanentlyDeleteItem', 'confirmationDialogShow', 'update:modelValue'],
  data() {
    return {
      showingDeleteConfirmDialog: false,
    };
  },
  methods: {
    onClickRestoreItem() {
      this.$emit('restoreItem');
      this.isShowingMenu = false;
    },
    onClickPermanentlyDeleteItem() {
      this.$emit('confirmationDialogShow');
      this.isShowingMenu = false;
      this.showingDeleteConfirmDialog = true;
    }
  },
  computed: {
    isShowingMenu: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>

</style>
